import React, { useState } from 'react';
import Navbar from '../../components/navbar';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import LockIcon from '@material-ui/icons/Lock';
import './style.scss';
import { Mail } from '@material-ui/icons';
import CustomSnackbar from '../../components/snack';
import { useForm } from 'react-hook-form';
import { getAvatar } from '../../components/avatar';
import RefreshIcon from '@material-ui/icons/Refresh';
// import { Context } from '../../store';
import axios from 'axios';
import CustomLoader from '../../components/loader/customLoader';
import { BACKURL } from '../../components/network';

const Register = (props) => {
  const [file, setFile] = useState(getAvatar);
  const { register, handleSubmit } = useForm();
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState('');
  const [loading, setloading] = useState(false);
  // const { dispatch } = useContext(Context);
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  const sendData = async (details) => {
    setloading(true);
    const data = await axios.post(`${BACKURL}/register`, details);
    setloading(false);
    // console.log(data.data);
    if (data.data.done) return true;
    setMsg(data.data.msg);
    setOpen(true);
  };
  const Submit = async (data) => {
    // console.log(data);
    if (data.re_password !== data.password) {
      setMsg(`Password didn't match!`);
      setOpen(true);
    } else {
      // console.log({ ...data, file });
      const res = await sendData({
        ...data,
        userImg: file,
      });
      if (res) props.history.push('/login');
    }
  };
  return (
    <>
      {loading ? <CustomLoader /> : null}
      <div className='register-wrapper'>
        <Navbar props={props} />
        <div className='usericon-wrapper'>
          <img className='user-img' src={file} alt='user-icon' />
        </div>
        <div
          className='del-icon'
          onClick={() => {
            setFile(getAvatar);
          }}>
          <RefreshIcon />
        </div>
        <form
          onSubmit={handleSubmit(Submit)}
          className='login-btn'
          style={{
            marginTop: '0px',
          }}>
          <div className='input-btn'>
            <Mail />
            <input
              type='email'
              placeholder='Email'
              ref={register}
              name='email'
              required
            />
          </div>
          <div className='input-btn'>
            <PersonOutlineIcon />
            <input
              placeholder='Username'
              ref={register}
              name='username'
              maxLength='10'
              required
            />
          </div>
          <div className='input-btn'>
            <LockIcon />
            <input
              type='password'
              placeholder='Password'
              ref={register}
              name='password'
              minLength='6'
              required
            />
          </div>
          <div className='input-btn'>
            <LockIcon />
            <input
              type='password'
              placeholder='Re-type Password'
              ref={register}
              name='re_password'
              minLength='6'
              required
            />
          </div>
          <button className='btn-reg'>Register</button>
        </form>
        <div className='redirect-btn'>
          Existing User? <a href='/login'>&nbsp;Login</a>
        </div>
        <CustomSnackbar open={open} handleClose={handleClose} msg={msg} />
      </div>
    </>
  );
};

export default Register;
